import {
  useToasts 
} from "@/hooks/Toasts/useToasts"
import mergeOperations from "@/util/shallowMerge"
import {
  useMutation 
} from "@apollo/client"
import {
  useCallback, useMemo, useRef, useState 
} from "react"
import DEFAULT_OPERATIONS from "./studentDiscounts.gql"

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const [, {
    addToast 
  }] = useToasts()

  const {
    afterSubmit, uploadRef 
  } = props
  const operations = mergeOperations(DEFAULT_OPERATIONS, props.operations)

  const {
    addStudentDiscountMutation 
  } = operations

  const [isLoading, setIsLoading] = useState(false)
  const [isUploadImage, setIsUploadImage] = useState(false)
  const [addStudentDiscount, {
    data, error: addStudentDiscountError 
  }] =
        useMutation(addStudentDiscountMutation, {
          fetchPolicy: "no-cache",
        })

  const formApiRef = useRef(null)

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        values 
      } = formState

      const {
        firstname, lastname, email 
      } = values

      setIsLoading(true)
      const {
        fileList, setFileList 
      } = uploadRef.current
      let image

      if (fileList.length) {
        image = fileList[0].thumbUrl
        setIsUploadImage(false)
      } else {
        if (!image) {
          const message = "Please upload your Image"

          addToast({
            type: "error",
            message: message,
            dismissable: true,
            timeout: 1000,
          })

          setIsLoading(false)

          return
        }

        setIsLoading(false)
        setIsUploadImage(true)

        return false
      }

      try {
        await addStudentDiscount({
          variables: {
            firstname,
            lastname,
            email,
            image,
            type_id: 1,
          },
        })

        setFileList([])

        formApiRef.current.reset()

        if (afterSubmit) {
          afterSubmit()
        }
      } catch (error) {
        if (process.env.NODE_ENV !== "production") {
          console.error(error)
        }
      } finally {
        setIsLoading(false)
      }
    },
    [addStudentDiscount, addToast, afterSubmit, uploadRef]
  )

  const errors = useMemo(
    () => new Map([["addStudentDiscountError", addStudentDiscountError]]),
    [addStudentDiscountError]
  )

  return {
    isLoading,
    errors,
    formApiRef,
    handleSubmit,
    response: data && data.addDiscountInfo,
    isUploadImage,
  }
}
